export const CREATE_USER_INTEGRATION_ACCOUNT_REQUEST =
  'CREATE_USER_INTEGRATION_ACCOUNT_REQUEST';
export const CREATE_USER_INTEGRATION_ACCOUNT_SUCCESS =
  'CREATE_USER_INTEGRATION_ACCOUNT_SUCCESS';
export const CREATE_USER_INTEGRATION_ACCOUNT_ERROR =
  'CREATE_USER_INTEGRATION_ACCOUNT_ERROR';

export const UPDATE_USER_INTEGRATION_ACCOUNT_REQUEST =
  'UPDATE_USER_INTEGRATION_ACCOUNT_REQUEST';
export const UPDATE_USER_INTEGRATION_ACCOUNT_SUCCESS =
  'UPDATE_USER_INTEGRATION_ACCOUNT_SUCCESS';
export const UPDATE_USER_INTEGRATION_ACCOUNT_ERROR =
  'UPDATE_USER_INTEGRATION_ACCOUNT_ERROR';

export const FETCH_USER_INTEGRATION_ACCOUNTS_REQUEST =
  'FETCH_USER_INTEGRATION_ACCOUNTS_REQUEST';
export const FETCH_USER_INTEGRATION_ACCOUNTS_SUCCESS =
  'FETCH_USER_INTEGRATION_ACCOUNTS_SUCCESS ';
export const FETCH_USER_INTEGRATION_ACCOUNTS_ERROR =
  'FETCH_USER_INTEGRATION_ACCOUNTS_ERROR ';

export const FETCH_VERSION_CONTROL_SERVERS_REQUEST =
  'FETCH_VERSION_CONTROL_SERVERS_REQUEST ';
export const FETCH_VERSION_CONTROL_SERVERS_SUCCESS =
  'FETCH_VERSION_CONTROL_SERVERS_SUCCESS ';
export const FETCH_VERSION_CONTROL_SERVERS_ERROR =
  'FETCH_VERSION_CONTROL_SERVERS_ERROR';

export const FETCH_USER_GROUPS_REQUEST = 'FETCH_USER_GROUPS_REQUEST';
export const FETCH_USER_GROUPS_SUCCESS = 'FETCH_USER_GROUPS_SUCCESS';
export const FETCH_USER_GROUPS_ERROR = 'FETCH_USER_GROUPS_ERROR';

export const FETCH_PROJECT_INFO_REQUEST = 'FETCH_PROJECT_INFO_REQUEST';
export const FETCH_PROJECT_INFO_SUCCESS = 'FETCH_PROJECT_INFO_SUCCESS';
export const FETCH_PROJECT_INFO_ERROR = 'FETCH_PROJECT_INFO_ERROR';
export const RESET_PROJECT_INFO = 'RESET_PROJECT_INFO';
